import { useQuery } from 'urql';
import { statePageQuery } from './statePageQuery';
import { getSlugFromPathname } from '../../helpers/getSlugFromPathname';
import { useUrlContext } from '../../contexts/UrlContext/UrlContext';

export const useStatePageQuery = () => {
  const { pathname } = useUrlContext();

  const [result] = useQuery({
    query: statePageQuery,
    variables: { slug: getSlugFromPathname(pathname) },
  });

  return result;
};
